export class EN {
    getTranslations() {
        return {
            btn_validate: 'OK',
            btn_cancel: 'Cancel',
            btn_close: 'Close',
            btn_add: 'Add',
            btn_delete: 'Delete',
            msg_alert: 'Alert',
            msg_success: 'Success',
            msg_confirm: 'Please confirm',
            msg_input: 'Input',
            datahub_pickup_indicator: 'Choose indicators',
            datahub_fields: 'Fields',
            config_menu_loading: 'Loading menu...',
            editable_label_edit: 'Click to edit',
            editable_label_validate: 'Validate',
            please_wait: 'Please wait...',
            combobox_placeholder: 'Select an option',
            card_button_start: 'Start',
            enter_credentials_to: 'Please enter your credentials to access ',
        };
    }
}
